const get_current_patient = () => (dispatch, getState) =>
  getState().patient_reducer.patient_object ?? getState().global_reducer.current_user.attributes.patient;

export default get_current_patient;
